//@ts-check

import { isSelfServePaidPlan } from "@functions/workspacePlans";

function creditPriceMatchesUsage(
    stripeCreditsPrice,
    { includedCredits, flexPricePerCredit, isTiered }
) {
    // isTiered are subscriptions with meter prices that have the included credits baked into the price
    // E.g. the price is $0 for the first 40 credits, then $2 per credit after that

    // Subscriptions that are not tiered have a fixed price per credit and we need to calculate the credits over the included
    // Note: this is only necessary for annual billing, as the plan cycle doesn't align w/ the flex cycle
    if (isTiered) {
        if (stripeCreditsPrice?.billing_scheme !== "tiered") {
            return false;
        }
        if (!stripeCreditsPrice?.tiers) {
            throw new Error("Tiered price must have tiers expanded to evaluate");
        }
        const freeTier = stripeCreditsPrice.tiers.find(
            (t) => t.up_to === includedCredits && t.unit_amount === 0
        );
        const paidTier = stripeCreditsPrice.tiers.find(
            (t) => t.up_to === null && t.unit_amount === flexPricePerCredit * 100
        );
        if (!freeTier || !paidTier) {
            return false;
        }
    } else {
        if (stripeCreditsPrice?.billing_scheme === "tiered") {
            return false;
        }

        if (stripeCreditsPrice?.unit_amount !== flexPricePerCredit * 100) {
            return false;
        }

        const includedCreditsFromMetadata = Number(stripeCreditsPrice?.metadata?.includedCredits);
        if (
            !isNaN(includedCreditsFromMetadata) &&
            includedCreditsFromMetadata !== includedCredits
        ) {
            return false;
        }
    }

    return true;
}

function prepaidCreditsPriceMatchesUsage(stripePrepaidCreditsPrice, { pricePerCredit }) {
    if (stripePrepaidCreditsPrice?.unit_amount !== pricePerCredit * 100) {
        return false;
    }
    return true;
}

function selfServePlanIsExpiring({ plan, subscription }) {
    if (!isSelfServePaidPlan(plan)) {
        return false;
    }
    return subscription?.cancellationPending && subscription?.isActive;
}

export { creditPriceMatchesUsage, prepaidCreditsPriceMatchesUsage, selfServePlanIsExpiring };
export default {
    creditPriceMatchesUsage,
    prepaidCreditsPriceMatchesUsage,
    selfServePlanIsExpiring
};
